import {
	Component,
	Input,
	ViewChildren,
	QueryList,
	ElementRef,
	HostListener,
	OnInit,
	OnDestroy,
	Output,
	EventEmitter,
	SimpleChange,
	OnChanges,
	AfterViewInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { HelperService } from '@app/core/services/helper.service';

@Component({
	selector: 'ui-tab-bar',
	templateUrl: './tab-bar.component.html',
	styleUrls: ['./tab-bar.component.less'],
})
export class UITabBarComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
	@Input() tabs: Array<any>;
	@Input() route_tabs: boolean = false;
	@Input() check_tabs: boolean = false;
	@Input() small_tabs: boolean = false;
	@Input() alt: boolean = false;
	@Input() align: string = 'left';
	@Input() css_class: string = '';
	@Input() always_underlined: boolean = false;
	@Input() starting_selected_index: number = 0;

	@Output() tab_change = new EventEmitter<number>();

	@ViewChildren('tab') tab_elements: QueryList<ElementRef>;

	selected_tab = {
		index: this.starting_selected_index,
		left: 0,
		width: 0,
	};

	highlight_static: boolean = true;
	tab_bar_css_class: string = '';

	destroyed$: Subject<boolean> = new Subject<boolean>();

	constructor(private router: Router, private helper_service: HelperService) {}

	ngOnInit(): void {
		this.tab_bar_css_class = this.getCssClass();

		if (this.route_tabs) {
			this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
				if (event instanceof NavigationEnd) {
					this.checkForActive();
				}
			});
		}
	}

	ngAfterViewInit(): void {
		if (!this.route_tabs) {
			this.showTab(this.starting_selected_index);
		}

		this.checkForActive();

		setTimeout(() => {
			this.highlight_static = false;
		}, 200);
	}

	ngOnChanges(simple_changes: { [propertyName: string]: SimpleChange }): void {
		if (
			!this.route_tabs &&
			simple_changes.hasOwnProperty('tabs') &&
			!this.helper_service.arraysMatch(simple_changes['tabs'].previousValue, simple_changes['tabs'].currentValue)
		) {
			this.showTab(this.starting_selected_index);
		}
	}

	getCssClass(): string {
		const classes = [];

		if (this.css_class !== '') {
			classes.push(this.css_class);
		}

		if (this.alt === true) {
			classes.push('alt');
		}

		if (this.check_tabs === true) {
			classes.push('check-tabs');
		}

		if (this.small_tabs === true) {
			classes.push('small-tabs');
		}

		if (this.always_underlined === true) {
			classes.push('always-underlined');
		}

		switch (this.align) {
			case 'left':
				classes.push('align-left');
				break;
			case 'center':
				classes.push('align-center');
				break;
			case 'right':
				classes.push('align-right');
				break;
		}

		return classes.join(' ');
	}

	showTab(index): void {
		this.selected_tab.index = index;
		this.tab_change.emit(index);
		this.checkForActive();
	}

	@HostListener('window:resize')
	checkForActive(): void {
		if (this.tab_elements) {
			setTimeout(() => {
				if (this.route_tabs) {
					const scope = this;

					this.tab_elements.forEach(function (elem, i): void {
						if (elem.nativeElement.classList.contains('active')) {
							scope.selected_tab.index = i;
							scope.selected_tab.left = elem.nativeElement.offsetLeft - 1;
							scope.selected_tab.width = elem.nativeElement.offsetWidth;

							return;
						}
					});
				} else {
					const active_tab = this.tab_elements.toArray()[this.selected_tab.index].nativeElement;

					this.selected_tab.left = active_tab.offsetLeft - 1;
					this.selected_tab.width = active_tab.offsetWidth;
				}
			});
		}
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
